import http from "../http-common";

class VolunteerRegulatoryExchangeService {
  getVolunteerRegulatoryExchange() {
    return http.get("/regulatory-exchange-volunteer-opp");
  }
}

export default new VolunteerRegulatoryExchangeService();